<!--
 * @Author: wzh
 * @LastEditTime: 2025-06-12 15:23:29
 * @Description: 登录页
-->
<template>
  <div :class="['loginPage hebi']">
    <div class="login-container">
      <div class="login-banner">
        <div class="login-logo">
          <img v-if="logoBase64" :src="logoBase64" alt="" />
        </div>
        <div class="line"></div>
        <div class="login-title-bh">
          <div class="chinese">{{ $t("login.title") }}</div>
          <div class="english">Unified identity authentication</div>
        </div>
      </div>

      <div class="login-main">
        <div class="login_wrap" v-if="loginType != 3">
          <!-- 扫码登录 -->
          <div
            class="mask_ban"
            v-if="loginSetInfo.smdl == 1"
            @click="loginTypeChange(3)"
          >
            <img src="@/assets/images/logo/mask_ban.png" alt="" />
          </div>
          <!-- 密码、验证码登录 -->
          <div class="login_tabs">
            <span @click="loginTypeChange(1)">
              {{ $t("login.type_account") }}
            </span>
            <span v-if="loginSetInfo.dtmdl == 1" @click="loginTypeChange(2)">
              {{ $t("login.type_phone") }}
            </span>
          </div>
          <div class="login_content">
            <div>
              <!-- 账号密码登录 -->
              <a-form-model
                v-if="loginType == 1"
                ref="loginForm"
                :model="formInline"
                :rules="rules"
                label-width="70px"
                class="demo-form-inline"
                @submit.native.prevent
              >
                <a-form-model-item label="" prop="username">
                  <a-input
                    class="login_form_input"
                    v-model="formInline.username"
                    @keyup.enter.native.stop="onSubmit"
                    :placeholder="$t('login.username_placeholder')"
                  >
                    <div slot="prefix" style="margin-right: 5px">
                      <img src="@/assets/images/icon/user_icon.png" alt="" />
                    </div>
                  </a-input>
                </a-form-model-item>
                <a-form-model-item label="" prop="password">
                  <a-input-password
                    class="login_form_input"
                    v-model="formInline.password"
                    @keyup.enter.native.stop="onSubmit"
                    :placeholder="$t('login.password_placeholder')"
                  >
                    <div slot="prefix" style="margin-right: 5px">
                      <img src="@/assets/images/icon/pass_icon.png" alt="" />
                    </div>
                  </a-input-password>
                </a-form-model-item>

                <!-- 验证码 -->
                <a-form-model-item
                  v-if="
                    (loginSetInfo.yzfs == 1 || loginSetInfo.yzfs == 3) &&
                    loginFailCount >= loginSetInfo.yzmcxsj
                  "
                  label=""
                  prop="captcha"
                >
                  <div class="valid-mask">
                    <a-input
                      class="login_form_input"
                      v-model="formInline.captcha"
                      :placeholder="$t('base.captcha.placeholder')"
                      @keyup.enter.native.stop="onSubmit"
                    >
                      <div slot="suffix">
                        <img
                          class="valid-mask-img"
                          :src="validMaskImage"
                          alt=""
                          @click="getValidMask"
                        />
                      </div>
                      <div slot="prefix" style="margin-right: 5px">
                        <img src="@/assets/images/icon/valid_icon.png" alt="" />
                      </div>
                    </a-input>
                  </div>
                </a-form-model-item>
              </a-form-model>

              <!-- 手机号登录 -->
              <a-form-model
                v-else-if="loginType == 2"
                ref="loginForm"
                :model="formInline"
                :rules="rules"
                label-width="70px"
                class="demo-form-inline"
                @submit.native.prevent
              >
                <a-form-model-item label="" prop="mobile">
                  <a-input
                    class="login_form_input"
                    v-model="formInline.mobile"
                    @keyup.enter.native.stop="onSubmit"
                    :placeholder="$t('base.mobile.placeholder')"
                  >
                    <div slot="prefix" style="margin-right: 5px">
                      <img src="@/assets/images/icon/user_icon.png" alt="" />
                    </div>
                  </a-input>
                </a-form-model-item>
                <a-form-model-item label="" prop="mobileCode" class="flex">
                  <a-input
                    class="login_form_input"
                    v-model="formInline.mobileCode"
                    :placeholder="$t('base.captcha.message_placeholder')"
                    @keyup.enter.native.stop="onSubmit"
                  >
                    <!-- <div slot="suffix">
											<a-divider type="vertical" />
											<span style="color: #999999; font-size: 14px" class="login-get-phone">获取验证码</span>
										</div> -->
                    <div slot="prefix" style="margin-right: 5px">
                      <img src="@/assets/images/icon/valid_icon.png" alt="" />
                    </div>
                  </a-input>
                  <div class="codeBox">
                    <a-button
                      v-if="count == 60"
                      type="primary"
                      @click="handleCode"
                      >{{ $t("base.btn.get_code") }}</a-button
                    >
                    <a-button type="primary" disabled v-else
                      >{{ count }}s</a-button
                    >
                  </div>
                </a-form-model-item>
              </a-form-model>

              <div class="login-desc">
                <div>
                  <a-checkbox
                    v-model="remeberMe"
                    v-if="loginSetInfo.qtmdl == 1"
                    >{{ $t("login.no_login") }}</a-checkbox
                  >
                </div>
                <div class="login-mm-jh">
                  <template v-if="loginSetInfo.zxbz == 1">
                    <span @click="handleHelp">{{
                      $t("login.online_help")
                    }}</span>
                    <a-divider type="vertical" />
                  </template>
                  <template v-if="basicSetInfo.zhjh == 1">
                    <span @click="handleActive">{{
                      $t("login.account_activation")
                    }}</span>
                    <a-divider type="vertical" />
                  </template>
                  <span @click="forgetPass">{{
                    $t("login.forget_password")
                  }}</span>
                </div>
              </div>

              <a-button
                class="login_form_button"
                type="primary"
                :loading="loginLoading"
                @click="onSubmit"
              >
                {{ $t("login.login_btn") }}
              </a-button>

              <!-- 第三方登录 -->
              <template v-if="loginArr.length">
                <a-divider class="third-login">第三方账号登录</a-divider>
                <div class="third-login-type">
                  <img
                    v-for="item in loginArr"
                    :src="
                      item.icon
                        ? require(`@/${item.icon}`)
                        : require('@/assets/images/social/default.png')
                    "
                    :key="item.id"
                    @click="loginOk(item)"
                  />
                  <img
                    v-if="loginMore.length"
                    src="@/assets/images/social/more.png"
                    @click="openMore"
                  />
                </div>
              </template>
            </div>
          </div>
        </div>
        <!-- 扫码登录 -->
        <div v-else class="login_wrap">
          <div class="login_content">
            <div class="shao">
              <div class="title">{{ $t("login.type_scan") }}</div>
              <div class="desc">{{ $t("login.scan_tips") }}</div>

              <!-- author: wzh, date: 2023-07-04, for: 钉钉扫码登录 -->
              <div id="self_defined_element" class="image">
                <!-- <img src="@/assets/images/logo/qr_code.png" alt="" /> -->
              </div>
              <div class="pass-login">
                <div>
                  {{ $t("login.scan_app_left")
                  }}<a style="color: var(--primary-color)">{{
                    $t("login.scan_app_name")
                  }}</a
                  >{{ $t("login.scan_app_right") }}
                </div>
                <div>
                  <a
                    style="color: var(--primary-color)"
                    @click="() => (loginType = 1)"
                    >{{ $t("login.type_password") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- 版权信息 -->
          <div class="copyrightInfo">{{ copyrightInfo }}</div>
        </div>
      </div>
      <!-- 版权信息 -->
      <div class="copyrightInfo">{{ copyrightInfo }}</div>
    </div>

    <!-- 滑块验证 -->
    <self-verify
      v-if="verifyVisible"
      @success="slideSuccess"
      @close="slideClose"
    ></self-verify>

    <!-- 忘记密码弹窗 -->
    <Dialog
      :title="$t('login.forget_password')"
      ref="forgetPass"
      width="900px"
      class="none-footer"
      :noneFooter="true"
    >
      <forget @success="() => $refs.forgetPass.closeModal()" />
      <template slot="butList">
        <div></div>
      </template>
    </Dialog>

    <!-- 账号激活弹窗 -->
    <Dialog
      :title="$t('login.account_activation')"
      ref="accountActive"
      width="900px"
      class="none-footer"
    >
      <activate
        :basicSetInfo="basicSetInfo"
        @success="() => $refs.accountActive.closeModal()"
        :noneFooter="true"
      />
      <template slot="butList">
        <div></div>
      </template>
    </Dialog>

    <!-- 更多登录方式 -->
    <Dialog ref="moreLogin" title="更多登录方式" width="400px">
      <div class="more_login_type">
        <div class="item" v-for="item in loginMore" :key="item.id">
          <img
            v-if="item.icon"
            :src="require(`@/${item.icon}`)"
            @click="loginOk(item)"
          />
          <img
            v-else
            src="@/assets/images/social/default.png"
            @click="loginOk(item)"
          />
          <div @click="loginOk(item)">{{ item.providerName }}</div>
        </div>
      </div>
      <template slot="butList">
        <div></div>
      </template>
    </Dialog>
    <ZhiyuLogin ref="zhiyuLoginComponent" :redirectUri="redirectUri" />
  </div>
</template>

<script>
import { commonAPI } from "@/apis";
import { Dialog } from "@/components/public/dialog/ant";
import SelfVerify from "@/components/public/selfVerify/SelfVerify"; // 滑块
import { loginErrorText } from "@/constants/loginError";
import { encryptAES, getUrlParam } from "@/utils";
import { currentLanguage } from "@/utils/helpers";
import { activate } from "@/views/activate"; // 账号激活组件
import ZhiyuLogin from "@/views/auth/zhiyu/index";
import { commonMethods } from "@/views/authPages/mixins/common";
import { forget } from "@/views/forget"; // 忘记密码组件

export default {
  name: "LoginPage",
  components: { Dialog, forget, activate, SelfVerify, ZhiyuLogin },
  mixins: [commonMethods],
  data() {
    return {
      formInline: {
        username: "",
        password: "",
        captcha: "",
        mobile: "",
        mobileCode: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: this.$t("login.username_placeholder"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("login.password_placeholder"),
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: this.$t("base.captcha.placeholder"),
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: this.$t("base.mobile.placeholder"),
            trigger: "blur",
          },
        ],
        mobileCode: [
          {
            required: true,
            message: this.$t("base.captcha.message_placeholder"),
            trigger: "blur",
          },
        ],
      },
      loginType: 1, // 登录类型 1，账号。2扫码
      validMaskImage: "", // 验证码
      stateToken: "", // 验证码返回的state 临时token
      basicSetInfo: {}, // 基础配置信息
      loginSetInfo: {}, // 登录配置信息
      verifyVisible: false, // 拼图弹窗
      loginFailCount: 0, // 登录失败次数
      remeberMe: false, // 七天免登陆
      loginLoading: false, // 登录按钮加载中
      count: 60, // 验证码倒计时
      copyrightInfo: "", // 版权
      logoBase64: "", // logo
      currentLanguage: "简体中文",
      loginArr: [], // 第三方登录方式
      redirectUri: "",
    };
  },
  created() {
    this.redirectUri = getUrlParam("redirect_uri");
    this.currentLanguage = currentLanguage(true).text;
    this.getLoginSet();
    this.getBasicSet();
    this.getSafeSet();
    this.getValidMask();
    this.getBqLogo();
    this.getLoginType();
  },
  watch: {
    // 监听路由变化
    $route: {
      handler() {
        this.checkUrlParams();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    loginFormat() {
      return this.loginArr; //.filter((o) => o.isSystem == 1);
    },
    loginMore() {
      return []; // this.loginArr.filter((o) => o.isSystem != 1);
    },
  },
  methods: {
    // 检查URL参数方法
    checkUrlParams() {
      const hash = window.location.hash;
      const queryString = hash.split("?")[1] || "";
      const urlParams = new URLSearchParams(queryString);
      const appid = urlParams.get("appid") || "";
      const encrypt = urlParams.get("encrypt") || "";
      if (appid && encrypt && !this.loginLoading) {
        console.log("URL参数变化，执行织语登录验证");
        this.onZhiyuLoginSubmit();
      }
    },
    // 获取登录配置
    async getLoginSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/login/get"
      );
      if (code == 0) {
        let obj = { ...data };
        this.loginSetInfo = obj;
        sessionStorage.setItem("LOGIN_SET_INFO", JSON.stringify(obj));
      } else {
        this.$message.error(message);
      }
    },
    // 获取基础配置
    async getBasicSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/basic/get"
      );
      if (code == 0) {
        let obj = { ...data };
        this.basicSetInfo = obj;
        sessionStorage.setItem("BASIC_SET_INFO", JSON.stringify(obj));
      } else {
        this.$message.error(message);
      }
    },
    // 获取安全配置
    async getSafeSet() {
      const { code, data, message } = await commonAPI.getAction(
        "setting/safe/get"
      );
      if (code == 0) {
        let obj = { ...data };
        sessionStorage.setItem("SAFE_SET_INFO", JSON.stringify(obj));
      } else {
        this.$message.error(message);
      }
    },
    // 获取版权、logo
    async getBqLogo() {
      const { code, data } = await commonAPI.getAction("/setting/logo/get");
      if (code == 0) {
        this.copyrightInfo = data.copyRight || "";
        this.logoBase64 = data.logoFileBase64 || "";
      }
    },
    // 登录切换
    loginTypeChange(key) {
      this.formInline = {
        username: "",
        password: "",
        captcha: "",
        mobile: "",
        mobileCode: "",
      };
      this.loginType = key;

      // author: wzh, date: 2023-07-03, for: 钉钉扫码登录
      if (key == 3) {
        this.$nextTick(async () => {
          const { data } = await commonAPI.getAction(
            `/logon/oauth20/getConfig/dingtalk`,
            { url: "thirdLogin" }
          );
          DDLogin({
            id: "self_defined_element",
            goto: encodeURIComponent(
              `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${data.appid}&response_type=code&scope=snsapi_login&state=${data.state}&redirect_uri=${data.redirect_uri}`
            ),
            style: "border: none; background-color: #fff;",
            width: "100%",
            height: "300",
          });

          let handleMessage = (event) => {
            let origin = event.origin;
            if (origin == "https://login.dingtalk.com") {
              let loginTmpCode = event.data;
              window.location.href = `https://oapi.dingtalk.com/connect/oauth2/sns_authorize?appid=${data.appid}&response_type=code&scope=snsapi_login&state=${data.state}&redirect_uri=${data.redirect_uri}&loginTmpCode=${loginTmpCode}`;
            }
          };

          if (typeof window.addEventListener != "undefined") {
            window.addEventListener("message", handleMessage, false);
          } else if (typeof window.attachEvent != "undefined") {
            window.attachEvent("onmessage", handleMessage);
          }
        });
      }
    },
    // 表单提交
    onSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          if (
            this.loginSetInfo.yzfs == 2 &&
            this.loginFailCount >= this.loginSetInfo.yzmcxsj
          ) {
            this.verifyVisible = true;
          } else {
            console.log("11111 :>> ", 11111);
            this.handleLogin();
          }
        } else {
          return false;
        }
      });
    },
    // 获取验证码
    async handleCode() {
      if (!this.formInline.mobile) {
        this.$message.warning(this.$t("base.mobile.placeholder"));
        return;
      }
      const { code, message } = await commonAPI.getAction(
        `/login/sendotp/${this.formInline.mobile}`
      );
      if (code == 0) {
        this.$message.success(message);
        // 开启倒计时
        this.count--;
        const timer = setInterval(() => {
          if (this.count > 0 && this.count <= 60) {
            this.count--;
          } else {
            this.count = 60;
            clearInterval(timer);
          }
        }, 1000);
      } else {
        this.$message.error(message);
      }
    },
    // 登录
    handleLogin() {
      let redirect_uri = getUrlParam("redirect_uri");
      let params = {
        username: "",
        password: "",
        captcha: "",
        authType: "normal",
        state: this.stateToken,
        remeberMe: this.remeberMe ? "1" : "0",
        serviceUrl: redirect_uri ? this.getBase64(redirect_uri) : "",
      };
      if (this.loginType == 1) {
        params.username = this.formInline.username;
        params.password = this.formInline.password;
        params.captcha = this.formInline.captcha;
        params.authType = "normal";
      } else if (this.loginType == 2) {
        params.username = this.formInline.mobile;
        params.password = this.formInline.mobileCode;
        params.authType = "mobile";
      }
      this.loginLoading = true;
      const data = { ...params };
      data.password = encryptAES(params.password);

      this.$store
        .dispatch("auth/login", data)
        .then((res) => {
          this.loginLoading = false;
          if (res.code == 0) {
            let obj = {
              user: {
                username: res.data.username,
                displayName: res.data.displayName,
                email: res.data.email,
                mobile: res.data.mobile,
              },
              token: res.data.token,
            };
            this.$store.commit("auth/setUser", obj.user);
            this.$store.commit("auth/setToken", obj.token);

            if (res.data.remeberMe) {
              this.$cookies.set("REMEMBER_ME", obj, "7d");
            }
            if (typeof this.setLoginCookies === "function") {
              this.setLoginCookies(obj.token, obj.user);
            }
            if (redirect_uri) {
              sessionStorage.setItem("REDIRECT_URI", redirect_uri);
            }
            // accoutIsXm=true表示该账户处于休眠状态
            const isSleep = res.data.accoutIsXm === true;
            let before_login = {
              noSingleLogin: res.data.noSingleLogin,
              editPwd: res.data.editPwd,
              showInfo: res.data.showInfo,
              userInfoConfim: res.data.userInfoConfim,
              secAuth: res.data.secAuth,
              isSleep,
            };
            sessionStorage.setItem(
              "BEFORE_LOGIN",
              JSON.stringify(before_login)
            );
            // 如果账户处于休眠状态 存储账户和密码
            isSleep &&
              sessionStorage.setItem(
                "LOGIN_INFO",
                JSON.stringify({
                  account: this.formInline.username,
                  password: this.formInline.password,
                })
              );
            this.jumpComputed();
          } else {
            this.$message.error(loginErrorText(res.code, res.message));
            this.loginFailCount = res.data.loginFailCount; // 登录失败次数
            this.getValidMask(); // 如果没成功则重新生成新的验证码
          }
        })
        .catch((err) => {
          console.log("err :>> ", err);
          // this.$message.error(err);
        });
    },
    // 得到验证码图片
    async getValidMask() {
      const { code, data } = await commonAPI.getAction("/captcha");
      if (code === 0) {
        this.validMaskImage = data.image;
        this.stateToken = data.state;
      }
    },
    // 激活弹窗
    handleActive() {
      this.$refs.accountActive.openModal();
    },
    // 打开忘记密码弹窗
    forgetPass() {
      this.$refs.forgetPass.openModal();
    },

    // author: wzh, date: 2023-05-29, for: 帮助文档 跳转修改
    handleHelp() {
      if (this.loginSetInfo.iszxbzwd == 1) {
        let routeUrl = this.$router.resolve({ path: "/help" });
        window.open(routeUrl.href, "_blank");
      } else if (this.loginSetInfo.istzdz == 1) {
        window.open(this.loginSetInfo.tzdz);
      }
    },

    // 关闭验证
    slideClose() {
      this.verifyVisible = false;
    },
    // 滑块验证成功
    slideSuccess() {
      this.verifyVisible = false;
      this.handleLogin();
    },
    // author: wzh, date: 2023-01-06, for: 语言切换
    languageChange(type) {
      let obj =
        type == "zh"
          ? { value: "zh", text: "简体中文" }
          : { value: "en", text: "English" };
      this.currentLanguage = obj.text;
      this.$i18n.locale = type;
      localStorage.setItem("language", JSON.stringify(obj));
      this.$bus.emit("change_lang");
    },

    // author: wzh, date: 2023-05-30, for: 获取联合登录方式
    async getLoginType() {
      const { code, data } = await commonAPI.getAction(
        "/login/socialsprovider/listToLogin"
      );
      if (code == 0 && Array.isArray(data)) {
        // 过滤掉无效的数据
        this.loginArr = data.filter((item) => item && typeof item === "object");
      } else {
        this.loginArr = [];
      }
    },

    // 更多登录方式弹窗
    openMore() {
      this.$refs.moreLogin.openModal();
    },

    // 第三方登录点击
    async loginOk(item) {
      // 检查是否为织语登录
      if (item.provider === "zhiyu" || item.providerName === "织语") {
        this.$refs.zhiyuLoginComponent.openZhiyuLogin();
        return;
      }
      const { code, data, message } = await commonAPI.getAction(
        `/logon/oauth20/authorize/${item.provider}`,
        {
          url: "thirdLogin",
        }
      );
      if (code == 0) {
        let redirect_uri = getUrlParam("redirect_uri");
        if (redirect_uri) {
          sessionStorage.setItem("REDIRECT_URI", redirect_uri);
        }
        window.location.href = data;
      } else {
        this.$message.error(message);
      }
    },
    // 织语登录
    async onZhiyuLoginSubmit() {
      // 优化参数获取逻辑
      const hash = window.location.hash;
      const queryString = hash.split("?")[1] || "";
      const urlParams = new URLSearchParams(queryString);

      let appid = urlParams.get("appid") || "";
      let encrypt = urlParams.get("encrypt") || "";

      // 如果没有必要的参数，直接返回
      if (appid === "" || encrypt === "") return;

      // 避免重复登录
      if (this.loginLoading) return;

      this.loginLoading = true;
      console.log("执行织语登录验证，参数:", { appid, encrypt });

      try {
        const res = await commonAPI.getAction("/login/zhiyuLogin", {
          appid,
          encrypt,
          msgSignature: urlParams.get("msgSignature"),
          timeStamp: urlParams.get("timeStamp"),
          nonce: urlParams.get("nonce"),
        });
        if (res.code == 0) {
          let obj = {
            user: {
              username: res.data.username,
              displayName: res.data.displayName,
              email: res.data.email,
              mobile: res.data.mobile,
            },
            token: res.data.token,
          };
          this.$store.commit("auth/setUser", obj.user);
          this.$store.commit("auth/setToken", obj.token);

          // 处理记住我和重定向
          if (res.data.remeberMe) {
            this.$cookies.set("REMEMBER_ME", obj, "7d");
          }
          if (typeof this.setLoginCookies === "function") {
            this.setLoginCookies(obj.token, obj.user);
          }

          const redirect_uri = sessionStorage.getItem("REDIRECT_URI");
          if (redirect_uri) {
            sessionStorage.setItem("REDIRECT_URI", redirect_uri);
          }

          // 处理登录前信息
          const isSleep = res.data.accoutIsXm === true;
          let before_login = {
            noSingleLogin: res.data.noSingleLogin,
            editPwd: res.data.editPwd,
            showInfo: res.data.showInfo,
            userInfoConfim: res.data.userInfoConfim,
            secAuth: res.data.secAuth,
            isSleep: isSleep,
          };
          sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(before_login));

          // 跳转到相应页面
          this.jumpComputed();
        } else {
          this.$message.error(loginErrorText(res.code, res.message));
        }
      } catch (error) {
        this.$message.error("织语登录失败：" + (error.message || error));
      } finally {
        this.loginLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loginPage::v-deep {
  user-select: none;
  color: $font-color;
  width: 100%;
  height: 100%;
  background: url("~@/assets/images/logo/bg.png") no-repeat center center / 100%
    100%;
  display: flex;
  align-items: center;
  justify-content: center;

  .login-container {
    width: 1200px;
    height: 100vh;
    padding: 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 1280px) {
      width: 900px;
    }
  }

  .login-banner {
    width: calc(100% - 400px);
    height: 100%;
    background: url("~@/assets/images/logo/banner.png") no-repeat center center /
      65%;

    .login-logo {
      width: 350px;
      height: 50px;

      & > img {
        display: block;
        width: 350px;
        height: 50px;
      }
    }

    .login-title {
      font-size: 20px;
      padding-left: 350px;
      display: flex;
      margin-top: 16px;

      & > span {
        transform: translate(-60%);
      }
    }
  }

  .login-main {
    width: 400px;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;

    .login-la {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .login_wrap {
    border: 1px solid rgba(0, 0, 0, 0.26);
    background-color: #fff;
    border-radius: 8px;
    width: 100%;
    position: relative;

    .mask_ban {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }

    .login_tabs {
      margin-top: 50px;
      font-size: 17px;
      color: #333333;
      display: flex;
      justify-content: space-around;
      padding: 0 45px;

      & > span {
        cursor: pointer;
        z-index: 1;
      }
    }

    .title {
      width: 100%;
      height: 8vh;
      line-height: 8vh;
      text-align: center;
      font-size: 3vmin;
      font-weight: 800;
      font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
    }

    .login_content {
      box-sizing: border-box;
      padding: 20px 25px 30px;

      .valid-mask {
        display: flex;
        justify-content: center;
        align-items: center;

        .ant-input-suffix {
          right: 0;
        }

        .valid-mask-img {
          width: 100px;
          height: 33px;
          margin-left: 5px;
          cursor: pointer;
        }
      }

      .ant-form-item.flex .ant-form-item-children {
        display: flex;
        align-items: center;

        .codeBox {
          width: 100px;
          margin-left: 12px;

          & > * {
            width: 100%;
          }
        }
      }

      .login-desc {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;

        .login-mm-jh {
          color: #ffffff;

          & > span {
            cursor: pointer;
          }
        }
      }

      .third-login {
        margin: 18px 0;
        color: #ccc;
        font-size: 14px;
        // display: none;
      }

      // 第三方logo
      .third-login-type {
        display: flex;
        justify-content: space-evenly;

        & > img {
          width: 30px;
          cursor: pointer;
        }
      }

      // 扫码
      .shao {
        .title {
          text-align: center;
          color: #000000;
          font-size: 20px;
        }

        .desc {
          color: #333333;
          font-size: 14px;
          text-align: center;
        }

        .image {
          // margin-top: 25px;
          text-align: center;
          transform: scale(0.8);
          margin: -35px 0 -20px;
        }

        .pass-login {
          color: #666666;
          // margin-top: 50px;
          text-align: center;

          & > div:last-child {
            margin-top: 25px;
          }
        }
      }
    }

    .login_form_input {
      .el-form-item__label {
        color: #fff;
      }
    }

    .login_form_button {
      width: 100%;
      margin-top: 10px;
    }
  }
}

::v-deep {
  .login_wrap .ant-input {
    padding-left: 35px;
  }

  // 滑块样式
  .slide-verify {
    .slide-verify-slider {
      margin: 20px 0 25px;
      height: 14px;
      border-radius: 7px;
      border: none;
      background-color: #e4e4e4;

      .slide-verify-slider-mask {
        border: none !important;
        height: 14px;
        background: #1979ff !important;
        border-radius: 10px 0 0 10px;
      }

      .slide-verify-slider-mask-item {
        width: 56px;
        height: 28px;
        background: #1979ff !important;
        box-shadow: 0px 0px 9px 0px rgba(25, 121, 255, 0.74) !important;
        border-radius: 19px;
        border: none !important;
        top: -7px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(-2px);

        &::before,
        &::after {
          display: inline-block;
          content: "";
          width: 2px;
          height: 12px;
          background: #fff;
          border-radius: 2px;
        }

        .slide-verify-slider-mask-item-icon {
          width: 2px;
          height: 12px;
          background: #fff;
          position: static;
          border-radius: 2px;
          display: inline-block;
          margin: 0 10px;
        }
      }
    }
  }

  // 更多登录
  .more_login_type {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 25%;
      text-align: center;
      font-size: 12px;
      padding: 10px 0;

      & > img {
        width: 30px;
        margin-bottom: 5px;
        cursor: pointer;
      }
    }
  }
}

.verifyModal::v-deep {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .verifyMain {
    padding: 0 20px 10px;
    background-color: #fff;
    border-radius: 10px;
    position: relative;

    .title {
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      color: #000;
      position: relative;

      .anticon {
        position: absolute;
        font-size: 16px;
        top: 24px;
        right: 0;
      }
    }

    .verifySuc {
      position: absolute;
      width: 320px;
      height: 168px;
      top: 64px;
      left: 20px;
      background-color: rgba(255, 255, 255, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;

      & > div {
        text-align: center;
        color: #2cd002;
        font-weight: 500;

        .anticon {
          font-size: 44px;
          margin-bottom: 10px;
        }
      }
    }
  }
}

// 弹窗样式
.none-footer::v-deep {
  .ant-modal-footer {
    display: none;
  }
}

.hebi {
  width: 100%;
  overflow: hidden;
  background: url("~@/assets/images/logo/hb-login_bg.png") no-repeat center
    center / 100% 100%;

  .login-container {
    width: 100vw;
    min-width: 600px;
    padding: 33px 104px 10px;
    // padding: 20px 85px 10px;
    box-sizing: border-box;
    flex-direction: column;
    justify-content: center;

    .login-banner {
      width: 100%;
      background: none;
      height: min-content;
      display: flex;
      flex-shrink: 0;
      align-self: flex-start;
      align-items: center;

      .login-logo {
        width: min-content;
        // min-width: 298px;
        min-width: 350px;
        min-height: 47px;
      }

      .line {
        width: 1px;
        height: 35px;
        margin: 0 20px;
        background-color: #ffffff;
      }

      .login-title-bh {
        color: #ffffff;
        line-height: 15px;
        font-weight: 700;

        .chinese {
          font-family: "MicrosoftSansSerif";
          font-size: 20px;
          font-weight: normal;
          color: #ffffff;
          line-height: 15px;
          letter-spacing: 8px;
        }

        .english {
          font-family: "MicrosoftSansSerif";
          font-weight: normal;
          font-size: 12px;
          color: #ffffff;
          line-height: 15px;
          text-align: left;
          font-style: normal;
        }
      }

      .login-logo > img {
        width: max-content;
      }
    }

    .login-main {
      width: max-content;
      height: min-content;
      flex: 1 1;
    }

    .ant-btn-primary {
      border: 0px;
      background-color: rgb(12, 134, 243) !important;
      border-color: rgb(12, 134, 243) !important;
    }
  }

  .login-mm-jh {
    color: #ffffff;

    & > span {
      cursor: pointer;
    }
  }

  .login_wrap {
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    width: 450px;
    color: #ffffff;
    margin: 0 auto;
    padding: 20px;

    .login_tabs {
      margin-top: 20px;
      color: #ffffff;

      span {
        font-size: 20px;
      }
    }

    :deep(.ant-input::placeholder) {
      color: #999;
      /* 更改为你想要的颜色 */
    }
  }

  .copyrightInfo {
    position: relative !important;
    flex-shrink: 0;
  }

  ::v-deep .ant-checkbox-wrapper span {
    color: #ffffff !important;
  }
}

.copyrightInfo {
  position: absolute;
  width: 100%;
  height: 20px;
  font-size: 14px;
  text-align: center;
  color: #fff;
}
</style>
